export default __webpack_public_path__ + "static/media/inventory_etiennethompson.fb16892d.png";